export default {
    listRunningReports: 'dev/listRunningReports',
    listFullReportQueue: 'dev/listFullReportQueue',
    getQuery: 'dev/getQuery'
};